<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('sidebarMinimize')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/"> </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto"> </CHeaderNav>
    <CHeaderNav class="mr-4">
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CDropdown
          inNav
          class="c-header-nav-items"
          placement="bottom-end"
          add-menu-classes="pt-0"
        >
          <template #toggler>
            <CHeaderNavLink>
              <CIcon name="cil-envelope-open" />
              <CBadge
                v-if="$store.state.data.notification.length"
                color="danger"
                >{{ $store.state.data.notification.length }}</CBadge
              >
            </CHeaderNavLink>
          </template>
          <div class="notificarion"></div>
          <CListGroup class="notificarion">
            <CListGroupItem
              v-html="item.content"
              :class="item.metadata.type"
              :href="notifiurl(item)"
              v-for="(item, index) in $store.state.data.notification"
              :key="index"
            >
            </CListGroupItem>

            <CListGroupItem
              v-if="$store.state.data.notification.length"
              class="readall"
              href="#"
              v-on:click="$store.commit('remove_all_notification')"
            >
              همه پیام‌ها را دیده‌ام
            </CListGroupItem>
            <CListGroupItem
              v-if="!$store.state.data.notification.length"
              class="no_notif"
            >
              هیچ پیغام جدیدی ندارید
            </CListGroupItem>
          </CListGroup>
        </CDropdown>
      </CHeaderNavItem>
      <TheHeaderDropdownAccnt />
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" />
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  methods: {
    notifiurl: function(item) {
      if(item.type==1)
        return '/voicemails#vm_'+item.id
      if(item.type==2)
        return '/ticket/'+item.metadata.ticket_id;
    },
  },
  components: {
    TheHeaderDropdownAccnt,
  },
};
</script>
